<template>
<div>
    <v-dialog v-model="cprDialog" fullscreen scrollable>
        <v-card>
            <v-toolbar dark color="green darken-2" max-height="65">
              <v-toolbar-title> Consolidate PR</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="clickCloseMainDialog()"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
          <v-card-text style="max-height: 900px;">
            <v-form @submit.prevent ref="formRefRFQ">
            <v-row class="mt-5">
              <v-col cols="12">
                <v-data-table
                  v-model="formdata.Lists"
                  :loading="loading"
                  :headers="headers"
                  :items="itemList"
                  :options.sync="options"
                  :search="searchText"
                  item-key="PRID"
                  show-select
                  :items-per-page="-1"
                  :footer-props="{
                    'items-per-page-options': [-1]
                  }"
                  class="elevation-1"
                >
                  <template v-slot:top>
                    <v-toolbar color="transparent" max-height="65" class="elevation-0">
                      <v-text-field label="Search here" v-model="searchText" outlined dense hide-details color="header"></v-text-field>
                    <v-spacer></v-spacer>
                    <v-autocomplete
                      color="green"
                      v-model="FundCode"
                      item-text="Description"
                      item-value="FundCode"
                      :items="FundCodes"
                      @change="getPRLists()"
                      dense
                      hide-details
                      outlined
                      class="mr-2"
                      style="max-width: 200px;"
                      label="Fund Code"
                    >
                    </v-autocomplete>
                    <v-btn color="header darken-1 white--text" @click="consolidate()" :loading="isLoading" :disabled="formdata.Lists.length <= 1"><v-icon class="mr-1">mdi-table-merge-cells</v-icon>CONSOLIDATE</v-btn>
                    </v-toolbar>
                  </template>
                  <template v-slot:[`item.PRCODE`]="{ item }">
                    <span class="text-no-wrap">{{ item.PRCODE }}</span>
                  </template>
                  <template v-slot:[`item.BudgetCode`]="{ item }">
                    <span class="text-no-wrap">{{ item.BudgetCode }}</span>
                  </template>
                  <template v-slot:[`item.PSUApprovedDate`]="{ item }">
                    <span class="text-no-wrap">{{ formatDate(item.PSUApprovedDate) }}</span>
                  </template>
                  <template v-slot:[`item.Status`]="{ item }">
                    <v-icon v-if="item.PRstatus == 1 || item.PRstatus >= 3" color="header">mdi-check-circle</v-icon>
                    <v-icon v-else color="amber darken-2">mdi-close-circle</v-icon>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn
                      x-small
                      outlined
                      color="blue darken-2"
                      dark
                      class="mr-2"
                      @click="viewPR(item)"
                    >
                      VIEW
                    </v-btn>
                </template>
                </v-data-table>
              </v-col>
            </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    <v-dialog v-model="dialogConsolidate" max-width="1200px" scrollable>
      <v-card>
        <v-card-title class="headline">
          Consolidation
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogConsolidate = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
        <v-card-text class="px-8" style="max-height: 900px">
          <v-form ref="formRefConsolidate">
          <v-textarea class="mt-3" label="Purpose" v-model="formdata.PRCPurpose" outlined :rules="[formRules.required]" dense color="header"></v-textarea>
          <v-expansion-panels class="mt-5" v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-header><strong>LIST OF SELECTED PRs</strong></v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-data-table
                    :headers="headers2"
                    :items="formdata.Lists"
                    item-key="PRID"
                    class="elevation-1 mt-4"
                >
                <!-- <template v-slot:top>
                  <v-toolbar flat>
                    <strong>List of PRs Selected</strong>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template> -->
                <template v-slot:[`item.UnitCost`]="{ item }">
                  <span class="text-no-wrap">₱ {{ formatPrice(item.UnitCost) || 0.00 }}</span>
                </template>
                <template v-slot:[`item.EditableQty`]="{ item }">
                  {{ formatQty(item.EditableQty) || 0 }}
                </template>
                <template v-slot:[`item.Amount`]="{ item }">
                  <span class="text-no-wrap">₱ {{ formatPrice(item.EditableQty * item.UnitCost) || 0.00 }}</span>
                </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header><strong>LIST OF ITEMS (MERGED)</strong></v-expansion-panel-header>
            <v-expansion-panel-content>
            <v-data-table
                :headers="headers3"
                :items="PRListItems"
                item-key="ppmpItemID"
                class="elevation-1 mt-4"
            >
            <!-- <template v-slot:top>
              <v-toolbar flat>
                <strong>List of Items (Merged)</strong>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template> -->
            <template v-slot:[`item.UnitCost`]="{ item }">
              <span class="text-no-wrap">₱ {{ formatPrice(item.UnitCost) || 0.00 }}</span>
            </template>
            <template v-slot:[`item.Qty`]="{ item }">
              {{ formatQty(item.Qty) || 0 }}
            </template>
            <template v-slot:[`item.Amount`]="{ item }">
              <span class="text-no-wrap">₱ {{ formatPrice(item.Amount) || 0.00 }}</span>
            </template>
            </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
          </v-expansion-panels>
          </v-form>
        </v-card-text>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-2" outlined @click="dialogConsolidate = false">Cancel</v-btn>
          <v-btn color="header" class="white--text" @click="submitConsolidate()"><v-icon class="mr-1">mdi-check-circle</v-icon> Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirm" max-width="500px">
      <v-card>
        <v-card-title class="headline">
          Confirmation
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogConfirm = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
        <v-card-text class="px-8" style="max-height: 900px">
          Are you sure you want to consolidate these Purchase Requests?
        </v-card-text>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-2" outlined @click="dialogConfirm = false">Cancel</v-btn>
          <v-btn color="header" class="white--text" @click="confirmConsolidate()"><v-icon class="mr-1">mdi-check-circle</v-icon> Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
    <prModal :prData="prItem" />
    </div>
</template>
    
<script>
  export default {
    components: {
    prModal: () => import("./PRViewItem"),
    },
  props : {
      cprDialog: null
  },
    data: () => ({
      headers: [
          {
        text: "PR No.",
        align: "start",
        sortable: false,
        value: "PRCODE",
      },
      {
        text: "Budget Code",
        value: "BudgetCode",
        sortable: false,
      },
      {
        text: "PR Purpose",
        value: "PrPurpose",
        sortable: false,
      },
      {
        text: "Date Verified",
        value: "PSUApprovedDate",
        sortable: false,
      },
      {
        text: "Actions",
        value: "actions",
        align: "center",
        sortable: false,
      },
        ],
      headers2: [
          {
        text: "PR No.",
        align: "start",
        sortable: false,
        value: "PRCODE",
      },
      {
        text: "Budget Code",
        value: "BudgetCode",
        sortable: false,
      },
      {
        text: "PR Purpose",
        value: "PrPurpose",
        sortable: false,
      },
      {
        text: "Date Verified",
        value: "PSUApprovedDate",
        sortable: false,
      }
        ],
      headers3: [
      //     {
      //   text: "Stock/Property No.",
      //   align: "start",
      //   sortable: false,
      //   value: "StockPropertyNo",
      // },
      {
        text: "Item name",
        value: "ItemName",
        sortable: false,
      },
      {
        text: "Item Description",
        value: "ItemDescription",
        width: 500,
        sortable: false,
      },
      {
        text: "Unit Cost",
        value: "UnitCost",
        sortable: false,
      },
      {
        text: "Qty",
        value: "Qty",
        sortable: false,
      },
      {
        text: "Amount",
        value: "Amount",
        sortable: false,
      },
      {
        text: "PRs",
        value: "PRCodes",
        width: 130,
        sortable: false,
      }
        ],
      loading: false,
      footerProps: {'items-per-page-options': [5, 10, 20, 50, 100, 500]},
      options: {},
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      itemList: [],
      formdata: {
      RFQType: null,
      dodID: null,
      Lists: [],
      PRCPurpose: null,
      },
      searchText: '',
      isLoading: false,
      dialogConsolidate: false,
      prItem: [],
      panel: 0,
      PRListItems: [],
      loadingItems: false,
      dialogConfirm: false,
      FundCode: null,
      FundCodes: [],
    }),
    watch: {
      cprDialog: {
        handler (data) {
        if(data == true){
          this.getFundCodes();
          this.getPRLists();
        }
        },
        deep: true,
      },
      searchText: {
        handler () {
        },
        deep: true,
      },
    },
    mounted(){
      this.eventHub.$on("closePRItemodal", () => {
      this.prItem = {};
      this.getFundCodes();
      this.getPRLists();
    });
    },
    beforeDestroy() {
    this.eventHub.$off("closePRItemodal");
  },
    created(){
      this.getDOD();
    },
    methods: {
      viewPR(item) {
      this.prItem = item;
    },
    consolidate(){
      this.dialogConsolidate = true;
      this.getPRListItems();
    },
    clickCloseMainDialog () {
        this.formdata = {
          RFQType: null,
          dodID: null,
          Lists: []
          }
        this.itemList =[];
        this.cprDialog = false;
        this.dialogConsolidate = false;
        this.dialogConfirm = false;
        this.eventHub.$emit('closeCPRModal', false);
    },
    getFundCodes() {
      this.axiosCall(
              '/get/getUniqueFundCodes',
              'GET'
          )
          .then((res) => {
              this.FundCodes = res.data.data;
          })
		},
      getPRLists() {
          if(this.FundCode){
          let data = new FormData();
          data.append("FundCode", this.FundCode);
          this.axiosCall(
          '/pr/consolidate/list',
          'POST',
          data
          )
          .then((res) => {
            this.loading = false;
            this.itemList = res.data.data;
            // this.formdata.Lists = this.itemList
            // this.selectAllToggle({items: this.itemList, value: true})
            // this.selectAllToggle({items: this.itemList, value: false})
          })
          }
      },
      getPRListItems() {
        this.loadingItems = false;
        let prids = [];
        this.formdata.Lists.forEach(item => {
          prids.push(item.PRID)
        });
        let data = new FormData();
        data.append("PRIDs", prids);
        this.axiosCall(
          '/pr/consolidate/items',
          'POST',
          data
          )
          .then((res) => {
            this.loadingItems = false;
            this.PRListItems = res.data.data;
          })
      },
      getDOD(){
        this.axiosCall("/get/all/POUtil", "POST", []).then((res) => {
          this.dodList = res.data.data.dod;
        });
      },
      // selectAllToggle(props) {
      //   if(this.formdata.Lists.length != this.itemList.length - this.disabledCount) {
      //     this.formdata.Lists = [];
      //     const self = this;
      //     props.items.forEach(item => {
      //       // if(!item.disabled) {
      //         self.formdata.Lists.push(item);
      //       // } 
      //     });
      //   } else this.formdata.Lists = [];
      // },
      submitConsolidate(){
        if(this.$refs.formRefConsolidate.validate()){
        this.dialogConfirm = true;
      }
      },
      confirmConsolidate(){
        if(this.$refs.formRefConsolidate.validate()){
          this.isLoading = true;
          let prids = [];
          this.formdata.Lists.forEach(item => {
            prids.push(item.PRID)
          });
          let data = new FormData();
          data.append('PRCPurpose', this.formdata.PRCPurpose);
          data.append('FundCode', this.FundCode);
          data.append('PRIDs', JSON.stringify(prids));
                      this.axiosCall(
                    '/pr/consolidate/add',
                    'POST',
                    data
                )
                .then((res) => {
                    if(res.data.status) {
                    this.dialogConsolidate = false;
                    this.dialogConfirm = false;
                    this.getPRLists();
                    window.open(this.apiUrl + "/pr/consolidated/report/" + res.data.data);
                    }else {
                    this.fadeAwayMessage.show = true;
                    this.fadeAwayMessage.type = 'error';
                    this.fadeAwayMessage.message = res.data.message;
                    this.fadeAwayMessage.header = 'System Message';
                    }
                    this.isLoading = false;
                })
        }
      },
    }
  }
</script>
    
<style scoped>
.v-dialog--fullscreen, .prModal {
  overflow-x: hidden !important;
}
</style>